import {useEffect, useState} from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Paper,
} from '@mui/material'
import {createTheme, ThemeProvider, useTheme} from '@mui/material/styles'
import * as locales from '@mui/material/locale'
import TableHeadBasic from './TableHead'
import './tablecomponent.css'

export default function TableComponent(props: any) {
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const [page, setPage] = useState(0)
  const [dense] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const theme = useTheme()
  const themeWithLocale = createTheme(theme, locales['esES'])

  useEffect(() => {
    setPage(0)
  }, [props.rows])

  const handleRequestSort = (event: any, property: string) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - props.rows.length) : 0

  function getComparator(order: string, orderBy: any) {
    return order === 'desc'
      ? (a: any, b: any) => descendingComparator(a, b, orderBy)
      : (a: any, b: any) => -descendingComparator(a, b, orderBy)
  }

  function descendingComparator(a: any, b: any, orderBy: any) {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  function stableSort(array: Array<any>, comparator: any) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) {
        return order
      }
      return a[1] - b[1]
    })
    return stabilizedThis.map((el: any) => el[0])
  }

  return (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '100%', mb: 2}}>
        <TableContainer>
          <Table
            sx={{minWidth: props.minWidth || 800}}
            aria-labelledby='tableTitle'
            size={dense ? 'small' : 'medium'}
            className='table-component-material'
          >
            <TableHeadBasic
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              headCells={props?.headCells || []}
              align={props.align}
            />
            <TableBody>
              {stableSort(props.rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any, index: number) => {
                  return (
                    <TableRow key={index}>
                      {props.headCells.map((col: any, index: number) => (
                        <TableCell align={col.align ? col.align : 'center'} key={index}>
                          {col?.render ? col.render(row) : row[col.indexData]}
                        </TableCell>
                      ))}
                    </TableRow>
                  )
                })}
              {emptyRows > 0 && (<TableRow ><TableCell colSpan={props.headCells.length} /></TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
        <ThemeProvider theme={themeWithLocale}>
          <TablePagination
            rowsPerPageOptions={props?.rowsPerPageOptions ?? [10]}
            component='div'
            count={props.rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{color: '#13ad90', fontWeight: 'bold'}}
            labelRowsPerPage={<span>Rows:</span>}
            labelDisplayedRows={({page}) => {
              return (
                <span
                  style={{
                    display: 'flex',
                    marginTop: '15%',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  Página: {page + 1}
                </span>
              )
            }}
            backIconButtonProps={{
              size: 'large',
            }}
            nextIconButtonProps={{
              size: 'large',
            }}
          />
        </ThemeProvider>
      </Paper>
    </Box>
  )
}
